import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ISkills, IMedium, IDateOptions, IDateOption, ITimeOptions, ITimeOption } from '../../interface/learning'
import { ILearningEntry } from '../../interface/learningEntry'
import { CLearningEntry } from '../../constants/learningEntry'

export interface learning {
    skills: Array<ISkills>;
    mediums: Array<IMedium>;
    dateOptions: Array<IDateOptions>;
    timeOptions: Array<ITimeOptions>;
    selectedDay: IDateOption;
    fromTime: ITimeOption;
    tillTime: ITimeOption;
    whatCanYouNow: string;
    selectedCategorysString: string;
    selectedCategorysArray: Array<IMedium>;
    editEntry: ILearningEntry;
    detailEntry: ILearningEntry;
    detailSubjects: Array<String>;
    detailTargets: String;
    compledetModal: boolean;
}

const initialState: learning = {
    skills: [],
    mediums: [],
    dateOptions: [],
    timeOptions: [],
    selectedDay: { value: "", label: "" },
    fromTime: { value: "Anfang", label: "" },
    tillTime: { value: "Ende", label: "" },
    whatCanYouNow: "",
    selectedCategorysString: "",
    selectedCategorysArray: [],
    editEntry: CLearningEntry,
    detailEntry: CLearningEntry,
    detailSubjects: [],
    detailTargets: "",
    compledetModal: false
}

export const learningSlice = createSlice({
    name: 'learning',
    initialState,
    reducers: {
        setSkills: (state, action: PayloadAction<Array<ISkills>>) => {
            state.skills = action.payload
        },

        setMediums: (state, action: PayloadAction<Array<IMedium>>) => {
            state.mediums = action.payload
        },

        setDateOptions: (state, action: PayloadAction<Array<IDateOptions>>) => {
            state.dateOptions = action.payload
        },

        setTimeOptions: (state, action: PayloadAction<Array<ITimeOptions>>) => {
            state.timeOptions = action.payload
        },

        setSelectedDay: (state, action: PayloadAction<IDateOption>) => {
            state.selectedDay = action.payload
        },

        setFromTime: (state, action: PayloadAction<ITimeOption>) => {
            state.fromTime = action.payload
        },

        setTillTime: (state, action: PayloadAction<ITimeOption>) => {
            state.tillTime = action.payload
        },

        setWhatCanYouNow: (state, action: PayloadAction<string>) => {
            state.whatCanYouNow = action.payload
        },

        setSelectedCategorysArray: (state, action: PayloadAction<Array<IMedium>>) => {
            state.selectedCategorysArray = action.payload

            let itemString: string = "";

            for (let index = 0; index < action.payload.length; index++) {
                itemString += action.payload[index].label + " / ";
            }

            itemString = itemString.slice(0, itemString.length - 3);

            state.selectedCategorysString = itemString
        },

        setEditEntry: (state, action: PayloadAction<ILearningEntry>) => {
            state.editEntry = action.payload
        },

        setDetailEntry: (state, action: PayloadAction<ILearningEntry>) => {
            state.detailEntry = action.payload
        },

        setDetailSubjects: (state, action: PayloadAction<Array<String>>) => {
            state.detailSubjects = action.payload
        },

        setDetailTargets: (state, action: PayloadAction<string>) => {
            state.detailTargets = action.payload
        },

        setCompledetModal: (state, action: PayloadAction<boolean>) => {
            state.compledetModal = action.payload
        },


    },
})

// Action creators are generated for each case reducer function
export const {
    setSkills,
    setMediums,
    setDateOptions,
    setTimeOptions,
    setSelectedDay,
    setFromTime,
    setTillTime,
    setWhatCanYouNow,
    setSelectedCategorysArray,
    setEditEntry,
    setDetailEntry,
    setDetailSubjects,
    setDetailTargets,
    setCompledetModal
} = learningSlice.actions

export default learningSlice.reducer